
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reviewers/listing",
      function () {
        return require("private-next-pages/reviewers/listing.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/reviewers/listing"])
      });
    }
  